import React from 'react';

// "Mira" AI-headhunter glyph — copied verbatim from the source design file.
// No equivalent exists in Penta's icon set (visuals package has no AI-assistant icon).
export function MiraSparkIcon({ size = 18 }: { size?: number }) {
    return (
        <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
            <defs>
                <mask id="mira-spark-gap">
                    <rect width="24" height="24" fill="white" />
                    <circle cx="17" cy="6.5" r="8.4" fill="black" />
                </mask>
            </defs>
            <path
                d="M7.9 20A9 9 0 1 0 4 16.1L2 22Z"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                mask="url(#mira-spark-gap)"
            />
            <path
                d="M17 0.3 C17.75 3.8 19.7 5.75 23.2 6.5 C19.7 7.25 17.75 9.2 17 12.7 C16.25 9.2 14.3 7.25 10.8 6.5 C14.3 5.75 16.25 3.8 17 0.3 Z"
                fill="currentColor"
            />
        </svg>
    );
}
